import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { MovePokemonsInput, MovePokemonsOutput } from "types/web-app";

export const movePokemons = async (
  accessToken: string,
  input: MovePokemonsInput
) => {
  try {
    const response = await fetchWithAuth("/box/move", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<MovePokemonsOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
